/**
 * User: WangMeng
 * Date: 2018-07-13
 * Time: 14:46
 * Desc: 监管统计公用公司表格
 */
import React from 'react';
import { Table } from 'antd';
import { SCORE_SORTS } from '../../../../constants/common';
import { ReportDateTypeText, ReportTypeText, ReportDateTypeMonth, ReportDateTypeDay } from '../../../../constants/info';
import cancel from '../../../../utils/cancel';
import messager from '../../../../utils/messager';
import { paramFilter, getSortType, getSortValue } from '../../../../utils/util';
import { numberFixed, provinceNameFormat } from '../../../../utils/formatter';
import Pagination from '../../../common/pagination/Pagination';
import TableSearch from '../../../common/tableSearch/TableSearch';
import { getCompanyStatisticReport, getReportView } from '../../../../services/regulatoryStatistical';

@cancel
export default class CompanyTable extends TableSearch {
    static defaultProps = {
        defaultSort: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            searchParams: {},
            sort: this.props.defaultSort,
            pageNum: 1,
            pageSize: 10,
            total: 0,
            link: '',
            data: [],
            loading: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const { searchParams } = this.props;
        const { searchParams: newParams } = nextProps;
        if(newParams !== searchParams) {
            this.onSearch({ ...newParams });
        }
    }

    onSearch = (searchParams) => {
        this.setState({
            searchParams,
            sort: this.props.defaultSort,
            pageNum: 1,
            total: 0
        }, () => {
            this.getData();
        });
    };

    getData = () => {
        let { pageNum, pageSize, searchParams, sort } = this.state;

        this.doCancel('list');
        this.setState({
            loading: true
        });
        getCompanyStatisticReport(paramFilter({ ...searchParams, pageNum, pageSize, sort }), this.addCancel('list')).then(data => {
            data = data || {};
            data.list && data.list.forEach((d, i) => {
                d.index = (pageNum - 1) * pageSize + i + 1;
                d.provinceName = provinceNameFormat(d.provinceName);
            });
            this.setState({
                loading: false,
                data: data.list,
                total: data.total || 0
            });
        }).catch(() => {
            this.setState({
                loading: false,
                data: []
            });
        });
    };

    handleTableChange = (pagination, filters, sorter)=> {
        let { field = '', order = '' } = sorter;
        let sort = getSortValue(order, SCORE_SORTS[field === 'fakeScore' ? 'FRAUD' : 'RISK']);
        this.setState({
            sort,
            pageNum: 1
        }, () => {
            this.getData();
        });
    };

    getReportName = (d) => {
        return `${d.reportYear}年${ReportDateTypeText[d.reportDateType]}${ReportTypeText[d.reportType]}`;
    };

    getReportLink = (d) => {
        let { link, reportDateType, reportYear, stockCode } = d;

        if (link === undefined) {
            getReportView({
                endDate: reportYear + ReportDateTypeMonth[reportDateType] + ReportDateTypeDay[reportDateType],
                stockCode
            }).then(data => {
                d.link = data || '';
                this.handleLink(d.link);
            });
        } else {
            this.handleLink(link);
        }
    };

    handleLink = (link) => {
        if (!link) {
            messager.info('暂无数据');
        } else {
            window.open(link);
        }
    };

    getColumns = () => {
        const { handleColumn } = this.props;
        const { sort } = this.state;
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 60
        }, {
            title: '股票代码',
            dataIndex: 'stockCode',
            width: 90
        }, {
            title: '公司简称',
            dataIndex: 'sesName',
            width: 100
        }, {
            title: '财报日期',
            dataIndex: 'reportName',
            width: 200,
            render: (v, d) => this.getReportName(d)
        }, handleColumn, {
            title: '证监会二级行业',
            dataIndex: 'secLevelName'
        }, {
            title: '财务舞弊评分',
            dataIndex: 'fakeScore',
            width: 125,
            sorter: true,
            sortOrder: getSortType(sort, SCORE_SORTS.FRAUD),
            render: (v) => numberFixed(v)
        }, {
            title: '财务风险评分',
            dataIndex: 'riskScore',
            width: 125,
            sorter: true,
            sortOrder: getSortType(sort, SCORE_SORTS.RISK),
            render: (v) => numberFixed(v)
        }, {
            title: '所在地',
            dataIndex: 'provinceName',
            width: 70
        }, {
            title: '财务报表',
            dataIndex: 'link',
            width: 80,
            render: (v, d) => <a href="javascript:void(0)" id="reportLink" onClick={() => this.getReportLink(d)}>查看</a>
        }];
    };

    render() {
        const { className } = this.props;
        const { pageNum, pageSize, total, data, loading } = this.state;
        return (
            <Table
                rowKey="index"
                className={className}
                loading={loading}
                pagination={false}
                onChange={this.handleTableChange}
                columns={this.getColumns()}
                dataSource={data}
                bordered
                footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/common/CompanyTable.jsx